// extracted by mini-css-extract-plugin
export default {"surfaceWhite":"landingSectionSurfaces_surfaceWhite__8Ggu7","surfaceMuted":"landingSectionSurfaces_surfaceMuted__ygS20"};